import React from "react"
import Element from "@bappweb/element"

const hasValue = value => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    parseFloat(value) === 0 ||
    Number.isNaN(value)
  ) {
    return false
  } else {
    return true
  }
}

export function requiredAmount(message) {
  return function(value, props) {
    if (!hasValue(value.amount) || !hasValue(value.currency)) {
      return (
        <Element type="span" className="form-error is-visible">
          {message || "Tutar ve Para birimi alanının girilmesi zorunludur"}
        </Element>
      )
    }
  }
}

export function minValueAmount(val, message) {
  return function(value, props) {
    if (hasValue(value.amount) && parseFloat(value.amount) < val) {
      return (
        <Element type="span" className="form-error is-visible">
          {message || "Tutar alanı " + val + " değerinden az olamaz"}
        </Element>
      )
    }
  }
}

export function maxValueAmount(val, message) {
  return function(value, props) {
    if (hasValue(value.amount) && parseFloat(value.amount) > val) {
      return (
        <Element type="span" className="form-error is-visible">
          {message || "Tutar alanı " + val + " değerinden fazla olamaz"}
        </Element>
      )
    }
  }
}
